"use client";

import { useEffect } from "react";

type ContentViewTrackerProps = {
	slug: string;
	type: "BLOG" | "MODULE";
	onViewsCount?: (count: number) => void;
};

export default function ContentViewTracker({ slug, type, onViewsCount }: ContentViewTrackerProps) {
	useEffect(() => {
		let cancelled = false;

		const trackView = async () => {
			try {
				const endpoint =
					type === "MODULE"
						? `/api/modules/${encodeURIComponent(slug)}/view`
						: `/api/blog-posts/${encodeURIComponent(slug)}/view`;
				const res = await fetch(endpoint, {
					method: "POST",
				});
				const result = (await res.json()) as {
					ok: boolean;
					data?: { viewsCount: number };
				};

				if (!cancelled && result.ok && typeof result.data?.viewsCount === "number") {
					onViewsCount?.(result.data.viewsCount);
				}
			} catch {
				// View tracking should never block reading the content.
			}
		};

		void trackView();

		return () => {
			cancelled = true;
		};
	}, [onViewsCount, slug, type]);

	return null;
}
